module.exports = __webpack_public_path__ + "static/AkzidenzGrotesk-MediumExtended-17d6fc441bc27ff7734c61c39867af4d.ttf";